export default __webpack_public_path__ + "static/media/G4D.979c6149.mp3";